<template>
  <b-modal ref="user-settings-modal" @ok="fuelTankModalOk">
    <template v-slot:modal-header="{}">
      <div>{{ $store.state.localization.data.mainPage.user.profileLabel }}</div>
    </template>
    <div style="font-size: 13px">
      <b-tabs>
        <FuelTanksTab ref="fuel-tanks-tab"></FuelTanksTab>
        <DriversTab ref="drivers-tab"></DriversTab>
        <NotificationsTab ref="notifications-tab"></NotificationsTab>
      </b-tabs>
    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
        $store.state.localization.data.common.table.cancel
      }}</b-button>
      <b-button variant="success" style="font-size: 12px" @click="ok()">{{
        $store.state.localization.data.common.table.ok
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>
import FuelTanksTab from "./FuelTanksTab.vue";
import DriversTab from "./DriversTab.vue";
import NotificationsTab from "./NotificationsTab.vue";
import { userService } from "../../../services";

export default {
  name: "UserSettings",
  components: {
    FuelTanksTab,
    DriversTab,
    NotificationsTab
  },
  data() {
    return {};
  },
  methods: {
    async open() {
      this.$refs["user-settings-modal"].show();
    },
    async fuelTankModalOk() {
      const userSettings = {
        settings: []
      };

      userSettings.settings.push({
        settingName: userService.FUEL_TANKS_TABLE_DISPLAYED_COLUMNS,
        settingValue: this.$refs["fuel-tanks-tab"].getDisplayedColumns().join()
      });

      userSettings.settings.push({
        settingName: userService.FUEL_TANKS_TABLE_HIDE_SUMMARY,
        settingValue: this.$refs["fuel-tanks-tab"].getHideSummary().toString()
      });

      userSettings.settings.push({
        settingName: userService.FUEL_VOLUME_PRECISION,
        settingValue: this.$refs["fuel-tanks-tab"].getFuelVolumePrecision().toString()
      });

      userSettings.settings.push({
        settingName: userService.DRIVERS_TABLE_DISPLAYED_COLUMNS,
        settingValue: JSON.stringify(this.$refs["drivers-tab"].getDisplayedColumns())
      });

      userSettings.settings.push({
        settingName: userService.NOTIFICATIONS_ENABLED,
        settingValue: this.$refs["notifications-tab"].getEnabled().toString()
      });
      
      const response = await userService.updateUserSettings(userSettings);

      if (response.isSuccess) {
        this.$store.dispatch("authentication/updateUserSettings", {
          userSettings: userSettings.settings
        });
        alert(this.$store.state.localization.data.common.entityUpdateSuccess.replace("[ENTITY_NAME]", this.$store.state.localization.data.mainPage.user.profileLabel));
      } else {
        alert(this.$store.state.localization.data.common.entityUpdateError.replace("[ENTITY_NAME]", this.$store.state.localization.data.mainPage.user.profileLabel));
      }
    },
  },
};
</script>